/**
 * Theme selection utilities and helper functions
 */

/**
 * Get computed color with dark mode support
 * @param {string} lightColor - Color for light mode
 * @param {string} darkColor - Color for dark mode
 * @returns {string} - The appropriate color based on current mode
 */
export function getColorByMode(lightColor, darkColor) {
  const isDark = document.documentElement.classList.contains("dark");
  return isDark ? darkColor : lightColor;
}

/**
 * Check if dark mode is currently enabled
 * @returns {boolean}
 */
export function isDarkModeEnabled() {
  return document.documentElement.classList.contains("dark");
}

/**
 * Apply dark mode class to an element
 * @param {HTMLElement} element
 */
export function applyDarkMode(element) {
  if (element) {
    element.classList.add("dark");
  }
}

/**
 * Remove dark mode class from an element
 * @param {HTMLElement} element
 */
export function removeDarkMode(element) {
  if (element) {
    element.classList.remove("dark");
  }
}

/**
 * Get theme configuration for components
 * Returns appropriate color values based on dark mode status
 */
export const themeConfig = {
  light: {
    bg: {
      primary: "#ffffff",
      secondary: "#f8fafc",
      tertiary: "#f1f5f9",
    },
    text: {
      primary: "#1e293b",
      secondary: "#475569",
      tertiary: "#64748b",
    },
    border: "#e2e8f0",
  },
  dark: {
    bg: {
      primary: "#0f172a",
      secondary: "#1e293b",
      tertiary: "#334155",
    },
    text: {
      primary: "#f8fafc",
      secondary: "#cbd5e1",
      tertiary: "#94a3b8",
    },
    border: "#475569",
  },
};

/**
 * Get current theme configuration
 * @returns {Object} - Current theme config
 */
export function getCurrentTheme() {
  return isDarkModeEnabled() ? themeConfig.dark : themeConfig.light;
}
